import { createContext, useContext, useEffect } from 'react'

/**
 * On a phone the page title lives in the dark header bar, not on the page.
 * The shell knows the route but not what a detail page is called, so a
 * detail view hands its title up through this. Desktop ignores it.
 */
export const MobileTitleContext = createContext<(title: string | null) => void>(() => {})

export function useMobileTitle(title: string | null | undefined): void {
  const set = useContext(MobileTitleContext)
  useEffect(() => {
    set(title ?? null)
    return () => set(null)
  }, [set, title])
}
